import React, { createContext, useEffect, useState } from "react";
import EpisodeStatus from "../../EpisodeStatus/EpisodeStatus";
import CodingScreen from "../../CodingScreen/CodingScreen";
import PlusIcon from "../../../common/assets/images/plus_icon.png";
import closeIcon from "../../../common/assets/images/close-icon.png";
import documentationIcon from "../../../common/assets/images/documentation.png";
import codeBookIcon from "../../../common/assets/images/codebook-icon.png";
import gridImage from "../../../common/assets/images/gridimg.png";
import DocumentViewer from "../../DocumentViewer/DocumentViewer";
import undo_icon from "../../../common/assets/images/undo.png";
import CodeBookDev from "../../CodeBook/CodeBookDev";
import CodeBookUsa from "../../CodeBook/CodeBookUsa";
import externalIcon from "../../../common/assets/images/link-external.png";
import {
  useLazyGetData1Query,
  useLazyGetData2Query,
} from "../../../store/apiSlice";
import {
  setLocalStorageItem,
  calculateAge,
  calculateLOS,
  replaceEmptyWithNull,
  formatDate,
} from "../../CodingScreen/utils";
import {
  getFilterEpisodeLists,
  selectedEpisodeList,
} from "../EpisodeList/redux/EpisodeListSlicer";
// import { lastCodedEpisode } from "../../DocumentViewer/redux/DocumentViewerSlicer";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import "../../pages/Coder/Coder.css";
import {
  fetchAllCodesbyStepFunction,
  fetchAllCodesProgress,
  fetchClusterWarnings,
  fetchPrincipalDiagnosisCodes,
  setClusterCodeWarningsWarningList,
  setCodeBookCard,
  setCodingScreenCard,
  setcurrentClusterID,
  setDocumentationCard,
} from "./redux/CoderSlicer";
import {
  Grid,
  Tooltip,
  useTheme,
  useMediaQuery,
  Card,
  Box,
  Button,
  Typography,
} from "@mui/material";
import LdsRoller from "../../../utils/LdsRoller";
import {
  fetchEpisodes,
  fetchDrgOptions,
  fetchDrgInformation,
} from "./redux/CoderSlicer";
import { setEpisodeIdentifierTopassDocumentViewer } from "../../DocumentViewer/redux/DocumentViewerSlicer";
import { parse, format, isValid } from "date-fns";
import { acceptCode, calculateDrgCode } from "../../CodingScreen/Service";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchCodersData } from "../../Codeworkflow/CoderView/redux/CoderScreenSlice";
import { getAuditorViewData } from "../../Codeworkflow/AuditorView/redux/AuditorViewSlicer";
import cloneDeep from "lodash/cloneDeep";
import axiosInstance from "../../../axiosinterceptor";
import { useNavigate } from "react-router-dom";
import {
  setRawSearchQuery,
  setActiveIcon,
  setActiveTab,
  setSearchByCodeId,
} from "../../CodeBook/redux/CodeBookSlicer";
import { handleResetSelectedDetails } from "../../CodeAssist/CodeSearch/redux/codeSearchSlice";
import WarningPanel from "../../CodeAssist/CodeSearch/WarningPanel";

// import { setDiagnosisStates, updatePrincipalDiagnosis, updateAdditionalDiagnosis, updateProcedureCodes } from '../../../store/CodingScreenSlice'; // Adjust path as necessary
export const CodeContext = createContext();

const Coder = () => {
  const navigate = useNavigate();
  const { activeTab, activeIcon, rawSearchQuery } = useSelector(
    (state) => state.codeBook
  );
  const { selectedCodeDetails } = useSelector((state) => state.codeSearch);

  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const codebookdevEnv = process.env.REACT_APP_FLAG_DEV;
  const codebookinternalEnv = process.env.REACT_APP_FLAG_INTERNAL;
  const codebookcoblhEnv = process.env.REACT_APP_FLAG_COBLH_DEV;
  const codebooknmhsEnv = process.env.REACT_APP_FLAG_NMHS;
  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const pallasaiTestCodebookEnv = process.env.REACT_APP_FLAG_PALLASAI_TEST;
  const codebooksanhcEnv = process.env.REACT_APP_FLAG_SAN_HC;
  const [isFetchingData1, setIsFetchingData1] = useState(false);

  // const [activeIcon, setActiveIcon] = useState("ICD");
  // const [activeTab, setActiveTab] = useState(
  //   codebookdevEnv ? "ICD 10 AM Index" : "ICD 10 CM Index"
  // );

  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const permissionList = Object.keys(permissions);

  // const docProcessordevEnv = process.env.REACT_APP_FLAG_DEV;
  // const docProcessorusaEnv = process.env.REACT_APP_FLAG_USA;
  // const docProcessorinternalEnv = process.env.REACT_APP_FLAG_INTERNAL;

  const codebookfigiEnv = process.env.REACT_APP_FLAG_FIJI_DEV;
  const [currentEpisode, setCurrentEpisode] = useState();
  const [currentStatus, setCurrentStatus] = useState("");
  const lastCodedEpisode = useSelector((state) => state.episodeList);
  const [iconDisplay, setIconDispaly] = useState(true);
  const [newlyInsertedCodes, setNewlyInsertedCodes] = useState([]);
  const [pendingCode, setPendingCode] = useState(null);
  const [pendingType, setPendingType] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [warningMessage, setWarningMessage] = useState();
  const insertingCodes = new Set();
  const checkModalStatus = JSON.parse(
    localStorage.getItem("episode-status-modal")
  );
  const [openStatusUpdatedModal, setOpenStatusUpdatedModal] = useState(false);
  const [currentEpisodeNumber, setCurrentEpisodeNumber] =
    useState(checkModalStatus);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  const { documentationCard, codingScreenCard, codeBookCard } = useSelector(
    (state) => state.coder.coderCard
  );
  const location = useLocation();
  const { documentviewerCurrentPage } = useSelector(
    (state) => state.documentViewer
  );
  const { episodeList } = useSelector((state) => state);
  const [selectedCodeBookCode, setSelectedCodeBookCode] = useState(null);
  const [copiedCodes, setCopiedCodes] = useState(null);
  const [selectedTabKeyCoding, setSelectedTabKeyCoding] = useState(null);
  const [warningModal, setWarningModal] = useState(false);
  const { episodeListFilterObj } = useSelector((state) => state.episodeList);
  const [auditedStatus, setAuditedStatus] = useState(false);
  const { coderFilter } = useSelector((state) => state.coderscreenqueue);
  const { auditorViewEpisodesPayload } = useSelector(
    (state) => state.auditorView
  );
  const last_hcp_line_id = localStorage.getItem("last_hcp_line_id");
  const [enableFinalize, setEnableFinalize] = useState(false);
  const [acceptedCodes, setAcceptedCodes] = useState({});
  const {
    episodesData,
    isEpisodesLoading,
    episodeError,
    currentClusterID,
    clusterIDs,
    injuryWithActivity,
    externalCauseCodes,
    placeOfOccurrence,
    activityCodes,
    injuryWithoutActivity,
  } = useSelector((state) => state.coder);
  const {
    clusterCodeWarningsIsLoading,
    clusterCodeWarningsWarningList,
    clusterCodeWarningsError,
  } = useSelector((state) => state.coder.clusterCodeWarnings);
  const {
    episodesFilterList,
    episodesFilterListLoading,
    episodesFilterListError,
  } = useSelector((state) => state.episodeList.viewEpisodesFiltersList);
  const codersData = useSelector((state) => state.coderscreenqueue.codersData);
  const { auditorViewData, auditorViewDataLoading, auditorViewDataError } =
    useSelector((state) => state.auditorView.auditorViewResponse);
  const [accepted, setAccepted] = useState({});
  const [trackHistory, setTrackHistory] = useState(() => {
    const storedTrackHistory = sessionStorage.getItem("trackHistory");
    return storedTrackHistory ? JSON.parse(storedTrackHistory) : [];
  });
  const [drgModalVisible, setDrgModalVisible] = useState(false);
  const [redoStack, setRedoStack] = useState(() => {
    const storedRedoStack = sessionStorage.getItem("redoStack");
    return storedRedoStack ? JSON.parse(storedRedoStack) : [];
  });
  const lastHcpLineId = localStorage.getItem("last_hcp_line_id");
  const [skipAcceptApi, setSkipAcceptApi] = useState(false);
  const [waitTillLoad, setWaitTillLoad] = useState(false);
  const [isDrgConfirmed, setIsDrgConfirmed] = useState(false);
  const [drgConfirmedStatusUpdate, setdrgConfirmedStatusUpdate] =
    useState(false);
  const [isLoadingCodingScreen, setIsLoadingCodingScreen] = useState(false);
  const [
    fetchData1,
    {
      data: data1,
      isLoading: isLoading1,
      isFetching: isFetching1,
      error: error1,
    },
  ] = useLazyGetData2Query();
  const [drgData, setDrgData] = useState({});
  const [selectedVersion, setSelectedVersion] = useState(
    codebookusaEnv ? "42.1" : null
  );
  const [drgValue, setDrgValue] = useState(data1?.data?.meta?.drg_code);
  const [weightValue, setweightValue] = useState("");
  const [drgloading, setDrgLoading] = useState(false);
  const [reimbursementValue, setReimbursementValue] = useState("");
  const [pasHyperLink, setPasHyperLink] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const typeOfPatient = lastCodedEpisode?.selectedEpisode?.type_patient; // or track `id` if available
  //const diagnosisStates = useSelector(state => state.codingScreen.diagnosisStates);

  const currentClusterIndex = clusterIDs?.indexOf(currentClusterID);
  const nextClusterCurrentIndex = clusterIDs[currentClusterIndex + 1];

  //Resetting the coding screen undo and redo stacks
  useEffect(() => {
    return () => {
      console.log("Component is about to be destroyed");
      sessionStorage.setItem("trackHistory", JSON.stringify([]));
      sessionStorage.setItem("redoStack", JSON.stringify([]));
      handleEpisodeChange();
    };
  }, []);

  useEffect(() => {
    if (location.pathname === "/Coder") {
      dispatch(setRawSearchQuery(""));
      // dispatch(setActiveIcon("ICD"))
      // dispatch(setActiveTab("ICD 10 AM Index"))
      // dispatch(setSearchByCodeId(null))
      dispatch(handleResetSelectedDetails());
    }
  }, []);

  const allDRGCodesTableData = useSelector(
    (state) => state?.coder?.drgOptionsData
  );
  const allDrgInformation = useSelector(
    (state) => state?.coder?.drgInformation
  );
  const drgOptionsLoading = useSelector(
    (state) => state?.coder?.loadingDrgOptionsData
  );
  const [diagnosisStates, setDiagnosisStates] = useState(() => {
    const loadState = (key, fallback) =>
      JSON.parse(localStorage.getItem(key)) || fallback;
    return {
      principal: loadState(
        "principalDiagnosisState",
        data1?.data?.principal_diagnosis ?? []
      ),
      additional: loadState(
        "additionalDiagnosisState",
        data1?.data?.additional_diagnoses ?? []
      ),
      procedure: loadState(
        "procedureCodesState",
        data1?.data?.procedure_codes ?? []
      ),
    };
  });

  const toggleCollapse = (collapseNumber) => {
    if (collapseNumber === 1) {
      // setDocumentationCard(!documentationCard);
      // setCodingScreenCard(true);
      // setCodeBookCard(true);
      dispatch(setDocumentationCard(!documentationCard));
      dispatch(setCodingScreenCard(true));
    } else if (collapseNumber === 2) {
      // setCodingScreenCard(!codingScreenCard);
      // setDocumentationCard(true);
      // setCodeBookCard(true);
      dispatch(setCodingScreenCard(!codingScreenCard));
      dispatch(setCodeBookCard(true));
    } else if (collapseNumber === 3) {
      // setCodeBookCard(!codeBookCard);
      // setDocumentationCard(true);
      // setCodingScreenCard(true);
      dispatch(setCodeBookCard(!codeBookCard));
      dispatch(setDocumentationCard(true));
    }
  };
  const new_hcp_line_id = localStorage.getItem("last_hcp_line_id");
  // useEffect(() => {
  //   const fetchAll = async () => {
  //     try {
  //       setIsLoadingCodingScreen(true);
  //       setDrgLoading(true);
  //       setWaitTillLoad(true);

  //       const results = await Promise.all([fetchData1()]);
  //       // console.log("All API responses:", results);
  //       // Step 1: Trigger the Step Function
  //       // const res = await dispatch(fetchAllCodesbyStepFunction());
  //       // const executionArn = res?.payload?.executionArn;

  //       // if (executionArn) {
  //       //   let status;

  //       //   // Step 2: Poll until status is SUCCEEDED
  //       //   while (true) {
  //       //     const progressRes = await dispatch(
  //       //       fetchAllCodesProgress(executionArn)
  //       //     );
  //       //     status = progressRes?.payload?.status;

  //       //     if (status === "SUCCEEDED") {
  //       //       break; // exit loop
  //       //     }

  //       //     if (status === "FAILED") {
  //       //       console.warn("Step function execution failed.");
  //       //       break; // exit loop even on failure
  //       //     }

  //       //     // Optional: log intermediate status
  //       //     console.log("Current status:", status);

  //       //     // Delay before next poll
  //       //     await new Promise((resolve) => setTimeout(resolve, 3000));
  //       //   }
  //       // } else {
  //       //   console.warn("executionArn not found. Skipping polling.");
  //       // }
  //     } catch (error) {
  //       console.error("Error during step function or polling:", error);
  //     } finally {
  //       // Step 3: Always fetch additional data
  //       try {
  //         await fetchData1();
  //       } catch (dataError) {
  //         console.error("Error in fetchData1:", dataError);
  //       }

  //       setIsLoadingCodingScreen(false);
  //       setDrgLoading(false);
  //       setWaitTillLoad(false);
  //     }
  //   };

  //   fetchAll();
  // }, [new_hcp_line_id]);

  // console.log('jcgshjasch',isLoading1);
  useEffect(() => {
    const fetchAll = async () => {
      try {
        setIsLoadingCodingScreen(true);
        setDrgLoading(true);
        setWaitTillLoad(true);

        // Await dispatch to complete
        // await dispatch(fetchACHICodes());
        // await dispatch(fetchPrincipalDiagnosisCodes());

        // Then call your fetchData
        const results = await Promise.all([fetchData1()]);
        // console.log("All API responses:", results);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoadingCodingScreen(false);
        setDrgLoading(false);
        setWaitTillLoad(false);
      }
    };

    fetchAll();
  }, [new_hcp_line_id]);
  useEffect(() => {
    const currentScreen = localStorage.getItem("currentPage");
    const newEpisodeListFilterObj = JSON.parse(localStorage.getItem("filters"));
    if (currentScreen === "episodeList") {
      dispatch(getFilterEpisodeLists(newEpisodeListFilterObj));
    } else if (currentScreen === "coderview") {
      dispatch(fetchCodersData(newEpisodeListFilterObj));
    } else if (currentScreen === "auditorPage") {
      dispatch(getAuditorViewData(newEpisodeListFilterObj));
    }
  }, [dispatch]);

  const currentScreen = localStorage.getItem("currentPage");
  const hcpLineId = Number(last_hcp_line_id);

  let newEpisodeRecord = null;
  if (currentScreen === "episodeList") {
    newEpisodeRecord = episodesFilterList?.episode?.find(
      (episode) => Number(episode?.hcp_line_id) === hcpLineId
    );
  } else if (currentScreen === "coderview") {
    newEpisodeRecord = codersData?.episodes?.find(
      (episode) => Number(episode?.hcp_line_id) === hcpLineId
    );
  } else if (currentScreen === "auditorPage") {
    newEpisodeRecord = auditorViewData?.episodes?.find(
      (episode) => Number(episode?.hcp_line_id) === hcpLineId
    );
  }

  const episodeSelected =
    episodeList?.selectedEpisode &&
    Object.keys(episodeList.selectedEpisode).length > 0
      ? episodeList.selectedEpisode
      : newEpisodeRecord;
  if (episodeSelected !== undefined && episodeSelected !== null) {
    localStorage.setItem("episodeDetails", JSON.stringify(episodeSelected));
  }

  const episodeDetailsFromStorage = JSON.parse(
    localStorage.getItem("episodeDetails")
  );

  useEffect(() => {
    if (episodeDetailsFromStorage) {
      dispatch(selectedEpisodeList(episodeDetailsFromStorage));
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("trackHistory", JSON.stringify(trackHistory));
  }, [trackHistory]);

  useEffect(() => {
    sessionStorage.setItem("redoStack", JSON.stringify(redoStack));
  }, [redoStack]);
  const syncCofWarning = (states) => {
  const principal = states?.principal?.[0];
  const cof = principal?.code ? getCOFValue(principal.code) : null;

  setWarningMessage((prev = []) => {
    // remove existing COF warnings
    const filtered = prev.filter((w) => !w.includes("COF"));

    // add warning only if COF exists and is not Y
    if (cof && cof !== "Y") {
      const warning = `Code ${principal.code.slice(1)} has COF ${cof}. Only COF = Y is recommended.`;

      return [warning, ...filtered];
    }

    return filtered;
  });
};

  const handleUndo = () => {
    if (trackHistory.length === 0) return;

    setRedoStack((prev) => {
      const newRedoStack = [{ diagnosisStates, acceptedCodes }, ...prev];
      sessionStorage.setItem("redoStack", JSON.stringify(newRedoStack));
      return newRedoStack;
    });

    const lastState = trackHistory[trackHistory.length - 1];
    setDiagnosisStates(lastState.diagnosisStates);
    setAcceptedCodes(lastState.acceptedCodes);
    syncCofWarning(lastState.diagnosisStates);
    setTrackHistory((prev) => {
      const newTrackHistory = prev.slice(0, -1);
      sessionStorage.setItem("trackHistory", JSON.stringify(newTrackHistory));
      return newTrackHistory;
    });
  };

  const handleRedo = () => {
    if (redoStack.length === 0) return;

    setTrackHistory((prev) => [...prev, { diagnosisStates, acceptedCodes }]);

    const nextState = redoStack[0];
    setDiagnosisStates(nextState.diagnosisStates);
    setAcceptedCodes(nextState.acceptedCodes);
    syncCofWarning(nextState.diagnosisStates);
    setRedoStack((prev) => {
      const newRedoStack = prev.slice(1);
      sessionStorage.setItem("redoStack", JSON.stringify(newRedoStack));
      return newRedoStack;
    });
  };
  const cleanCodes = (codes) =>
    codes?.map((code) =>
      code?.replace(/[.\-']/g, "").replace(/\s*\[.*?\]\s*/g, "")
    );

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const parsedDate = parse(dateString, "dd-MM-yyyy", new Date());
    return isValid(parsedDate) ? parsedDate : null;
  };

  const calculate_drg = async () => {
    const hcp_line_id = localStorage.getItem("last_hcp_line_id");
    const module_name =
      location.pathname === "/Code-Assist" ||
      location.pathname === "/Auditor-CodeAssist-Screen"
        ? "Code Assist"
        : "Code Accelerate";
    if (!data1?.data) return;
    const meta = data1.data.meta || {};
    const { principal, additional, procedure } = diagnosisStates;
    const procedures = cleanCodes(procedure.map((item) => item?.code));
    const additionalDiagnoses = cleanCodes(
      additional.map((item) =>
        ["1", "2"]?.includes(item.code[1])
          ? item?.code?.slice(2)
          : item?.code?.slice(1)
      )
    );
    const principalDiagnosis =
      principal.length > 0
        ? cleanCodes([
            ["1", "2"].includes(principal[0]?.code?.[1])
              ? principal[0]?.code?.slice(2)
              : principal[0]?.code?.slice(1),
          ])[0]
        : "";
    const admissionDate = parseDate(meta.admission_date);
    const separationDate = parseDate(meta.separation_date);
    const birthDate = parseDate(meta.date_of_birth);
    const los = calculateLOS(admissionDate, separationDate);
    // console.log( separationDate,'lllu');

    const { ageyears, agedays } = calculateAge(
      birthDate,
      admissionDate,
      admissionDate
    );
    const sdf = los > 1 ? 1 : 0;
    const payload = replaceEmptyWithNull({
      adm_date: formatDate(meta.admission_date),
      sep_mode: meta.mode_of_separation || "",
      bir_date: formatDate(meta.date_of_birth),
      adm_wt: meta.birthweight_infantneonatestillborn || 0,
      ageyears,
      agedays,
      sex: meta.sex || "",
      hmv: meta.hours_of_mechanical_ventilation || 0,
      principal_diagnosis_code: principalDiagnosis || [],
      procedure_codes: procedures || [],
      additional_diagnosis: additionalDiagnoses || [],
      los: String(los),
      leavedays: String(meta.total_leave_days || ""),
      sdf: String(sdf),
      sep_date: formatDate(meta.separation_date),
    });
    const newPayload = {
      hcp_line_id: hcp_line_id,
      module_name: module_name,
      drg_payload: { ...payload },
    };

    try {
      setDrgLoading(true);
      const response = await calculateDrgCode(newPayload);
      // const version = selectedVersion?selectedVersion:"11";
      const version = codebookusaEnv ? "42.1" : "11";
      const versionObj = response.data?.drgs?.find((item) => item[version]);
      const selectedDrgVersion = versionObj?.[version];
      setDrgData(response.data);
      // const { drg = "N/A", weight = " ", reimbursement } = response.data;
      const drgValue = selectedDrgVersion?.drg ?? "N/A";
      console.log(
        selectedDrgVersion,
        "selectedDrgVersion",
        response,
        versionObj,
        drgValue
      );
      const weightValue = selectedDrgVersion?.weight ?? "N/A";
      const reimbursementValue = selectedDrgVersion?.reimbursement ?? "N/A";

      setDrgValue(drgValue);
      setweightValue(weightValue);
      setReimbursementValue(reimbursementValue);
    } catch (error) {
      console.error("Error submitting diagnosis:", error);
    } finally {
      setDrgLoading(false);
    }
  };
  const getCOFValue = (code) => {
    if (!code) return null;
    return code.charAt(0); // Y / 1 / 2
  };
  const handleDRGOptions = () => {
    if (!data1?.data) return;
    const meta = data1.data.meta || {};

    const { principal, additional, procedure } = diagnosisStates;
    const procedures = procedure.map((item) => item?.code);
    const additionalDiagnoses = cleanCodes(
      additional.map((item) => item?.code?.slice(1))
    );
    const principalDiagnosis =
      principal.length > 0 ? cleanCodes([principal[0]?.code?.slice(1)])[0] : "";
    const diagnosisCodes = [
      ...diagnosisStates.principal,
      ...diagnosisStates.additional,
    ].map((item) => ({
      code: item.code,
      Description: item.description,
    }));
    const admissionDate = parseDate(meta.admission_date);
    const separationDate = parseDate(meta.separation_date);
    const birthDate = parseDate(meta.date_of_birth);
    const los = calculateLOS(admissionDate, separationDate);
    //console.log(birthDate,admissionDate,'lllu');

    const { ageyears, agedays } = calculateAge(
      birthDate,
      admissionDate,
      admissionDate
    );
    const sdf = los > 1 ? 1 : 0;
    const payload = replaceEmptyWithNull({
      adm_date: formatDate(meta.admission_date),
      sep_mode: meta.mode_of_separation || "",
      bir_date: formatDate(meta.date_of_birth),
      adm_wt: meta.birthweight_infantneonatestillborn || 0,
      ageyears,
      agedays,
      sex: meta.sex || "",
      hmv: meta.hours_of_mechanical_ventilation || 0,
      procedure_codes: procedures || [],
      diagnosis_code: diagnosisCodes || [],
      los: String(los),
      leavedays: String(meta.total_leave_days || ""),
      sdf: String(sdf),
      sep_date: formatDate(meta.separation_date),
    });

    dispatch(fetchDrgOptions(payload));
    setDrgModalVisible(true);
  };
  // console.log(allDRGCodesTableData, "allDRGCodesTableData");
  // const cleanCode = (code) => code.replace(/\./g, '').toUpperCase();

  const updateDiagnosisStateFromSelectedCode = (
    diagnosisState,
    selectedCode
  ) => {
    const principalCode = selectedCode.principal_diagnosis;
    const additionalCodes = selectedCode.additional_diagnoses || [];
    const procedureCodes = Array.isArray(selectedCode.procedure_codes_main)
      ? selectedCode.procedure_codes_main
      : [selectedCode.procedure_codes_main];

    const allDiagnosisItems = [
      ...(diagnosisState.principal || []),
      ...(diagnosisState.additional || []),
    ];

    const getDiagnosisEntry = (code) => {
      const cleaned = code;
      return allDiagnosisItems.find((item) => item.code === cleaned);
    };

    const newPrincipal = principalCode
      ? [getDiagnosisEntry(principalCode)].filter(Boolean)
      : [];

    const newAdditional = additionalCodes
      .map((code) => getDiagnosisEntry(code))
      .filter(Boolean)
      .filter((entry) => !newPrincipal.some((p) => p.code === entry.code));

    const getProcedureEntry = (code) => {
      const cleaned = code;
      return (diagnosisState.procedure || []).find((p) => p.code === cleaned);
    };

    const newProcedures = procedureCodes.map(getProcedureEntry).filter(Boolean);
    // console.log(newPrincipal[0].code,'seeprinc');

    return {
      principal: newPrincipal,
      additional: newAdditional,
      procedure: newProcedures,
    };
  };

  const handleOkClick = () => {
    setSkipAcceptApi(false);
    const lastHcpLineId = localStorage.getItem("last_hcp_line_id");
    const drgKey =
      location.pathname === "/Auditor-Coding-Screen" ||
      location.pathname === "/Auditor-CodeAssist-Screen"
        ? "audit_drg_code"
        : "drg_code";
    if (selectedRowIndex === null) {
      alert("Please select a row");
      return;
    }

    const selectedDRG = allDRGCodesTableData[selectedRowIndex];
    // console.log("Selected DRG:", selectedDRG, diagnosisStates);
    if (!data1?.data) return;
    const meta = data1.data.meta || {};
    const { principal_diagnosis, additional_diagnoses, procedure_codes_main } =
      selectedDRG;
    const procedures = procedure_codes_main;
    const additionalDiagnoses = cleanCodes(
      additional_diagnoses.map((code) => code.slice(1))
    );
    const principalDiagnosis = principal_diagnosis
      ? cleanCodes([principal_diagnosis.slice(1)])[0]
      : "";
    const admissionDate = parseDate(meta.admission_date);
    const separationDate = parseDate(meta.separation_date);
    const birthDate = parseDate(meta.date_of_birth);
    const los = calculateLOS(admissionDate, separationDate);
    //console.log(birthDate,admissionDate,'lllu');

    const { ageyears, agedays } = calculateAge(
      birthDate,
      admissionDate,
      admissionDate
    );
    const sdf = los > 1 ? 1 : 0;
    const drgPayload = replaceEmptyWithNull({
      adm_date: formatDate(meta.admission_date),
      sep_mode: meta.mode_of_separation || "",
      bir_date: formatDate(meta.date_of_birth),
      adm_wt: meta.birthweight_infantneonatestillborn || 0,
      ageyears,
      agedays,
      sex: meta.sex || "",
      hmv: meta.hours_of_mechanical_ventilation || 0,
      principal_diagnosis_code: principalDiagnosis || [],
      procedure_codes: procedures || [],
      additional_diagnosis: additionalDiagnoses || [],
      los: String(los),
      leavedays: String(meta.total_leave_days || ""),
      sdf: String(sdf),
      sep_date: formatDate(meta.separation_date),
    });
    // setDiagnosisStates({ principal: principalDiagnosis, additional: additionalDiagnoses, procedure: procedures});
    // console.log(diagnosisStates, "blockdiag");
    const updatedDiag = updateDiagnosisStateFromSelectedCode(
      diagnosisStates,
      selectedDRG
    );
    const selectedPrincipal = updatedDiag.principal?.[0];
    const cof = selectedPrincipal?.code
      ? getCOFValue(selectedPrincipal.code)
      : null;

    setWarningMessage((prevWarnings = []) => {
      // remove any existing COF-related warning
      const filteredWarnings = prevWarnings.filter((w) => !w.includes("COF"));

      // if COF is NOT Y → add warning
      if (cof && cof !== "Y") {
        const cofWarning = `Code ${selectedPrincipal.code.slice(
          1
        )} has COF ${cof}. Only COF = Y is recommended.`;

        return [cofWarning, ...filteredWarnings];
      }

      // if COF === Y → just return warnings without COF
      return filteredWarnings;
    });

    setDiagnosisStates({
      principal: updatedDiag.principal,
      additional: updatedDiag.additional,
      procedure: updatedDiag.procedure,
    });
    // const payload = {
    //   hcp_line_id: lastHcpLineId,
    //   principal_diagnosis_code: diagnosisStates.principal,
    //   additional_diagnoses_code: diagnosisStates.additional,
    //   procedure_codes: diagnosisStates.procedure,
    //   [drgKey]: drgValue ?? "",
    //   is_confirmed: false,
    // };
    // setTimeout(()=>{
    //   acceptCode(payload)
    // },300)
    // calculate_drg();
    setDrgModalVisible(false);
  };
  // console.log(diagnosisStates, "optidiag");

  const handleDrgInformation = () => {
    if (!data1?.data) return;
    const meta = data1.data.meta || {};
    const { principal, additional, procedure } = diagnosisStates;
    const procedures = cleanCodes(procedure.map((item) => item?.code));
    const additionalDiagnoses = cleanCodes(
      additional.map((item) => item?.code?.slice(1))
    );
    const principalDiagnosis =
      principal.length > 0 ? cleanCodes([principal[0]?.code?.slice(1)])[0] : "";
    const admissionDate = parseDate(meta.admission_date);
    const separationDate = parseDate(meta.separation_date);
    const birthDate = parseDate(meta.date_of_birth);
    const los = calculateLOS(admissionDate, separationDate);
    //console.log(birthDate,admissionDate,'lllu');

    const { ageyears, agedays } = calculateAge(
      birthDate,
      admissionDate,
      admissionDate
    );
    const sdf = los > 1 ? 1 : 0;
    const payload = replaceEmptyWithNull({
      hcp_line_id: lastHcpLineId,
      drg: drgValue,
      adm_date: formatDate(meta.admission_date),
      sep_mode: meta.mode_of_separation || "",
      bir_date: formatDate(meta.date_of_birth),
      adm_wt: meta.birthweight_infantneonatestillborn || 0,
      ageyears,
      agedays,
      sex: meta.sex || "",
      hmv: meta.hours_of_mechanical_ventilation || 0,
      principal_diagnosis_code: principalDiagnosis || [],
      procedure_codes: procedures || [],
      additional_diagnosis: additionalDiagnoses || [],
      los: String(los),
      leavedays: String(meta.total_leave_days || ""),
      sdf: String(sdf),
      sep_date: formatDate(meta.separation_date),
    });
    dispatch(fetchDrgInformation(payload));
  };
  // console.log(allDrgInformation, "allDrgInformation");
  const saveToHistory = () => {
    setTrackHistory((prev) => [
      ...prev,
      cloneDeep({ diagnosisStates, acceptedCodes }),
    ]);
    setRedoStack([]);
  };
  // console.log(diagnosisStates, "alldrgassist");
  const handleAccept = async (
    code = null,
    newCode = null,
    type = null,
    updatedState = null
  ) => {
    setEnableFinalize(true); // Start loading

    return new Promise(async (resolve) => {
      try {
        const drgKey =
          location.pathname === "/Auditor-Coding-Screen" ||
          location.pathname === "/Auditor-CodeAssist-Screen"
            ? "audit_drg_code"
            : "drg_code";
        const episodeStatus =
          (location.pathname === "/Auditor-Coding-Screen" ||
            location.pathname === "/Auditor-CodeAssist-Screen") &&
          auditedStatus;

        const currentState = updatedState || diagnosisStates;
        const allPrincipalCodes = currentState?.principal?.map(
          (item) => item.code
        );
        const allAdditionalCodes = currentState?.additional?.map(
          (item) => item?.code
        );
        const allProcedureCodes = currentState?.procedure?.map(
          (item) => item?.code
        );

        const payload = {
          hcp_line_id: lastHcpLineId,
          principal_diagnosis_code: allPrincipalCodes?.join(","),
          additional_diagnoses_code: allAdditionalCodes,
          procedure_codes: allProcedureCodes,
          [drgKey]: drgValue ?? "",
          is_confirmed: false,
          ...((location.pathname === "/Auditor-Coding-Screen" ||
            location.pathname === "/Auditor-CodeAssist-Screen") && {
            is_audited: false,
          }),
        };

        const isAccepted = await acceptCode(payload, location.pathname);
        if (isAccepted) {
          const updatedAccepted = { ...accepted, [code]: false };
          setAccepted(updatedAccepted);
          setLocalStorageItem("acceptedCodes", updatedAccepted);
        }
      } catch (error) {
        console.error("Error in handleAccept:", error);
      } finally {
        setEnableFinalize(false); // End loading regardless of success or error
        resolve();
      }
    });
  };
  const handleConfirmDrg = () => {
    // console.log("entered drg");
    setAuditedStatus(true);
    const drgKey =
      location.pathname === "/Auditor-Coding-Screen" ||
      location.pathname === "/Auditor-CodeAssist-Screen"
        ? "audit_drg_code"
        : "drg_code";
    const episodeStatus =
      location.pathname === "/Auditor-Coding-Screen" ||
      location.pathname === "/Auditor-CodeAssist-Screen";

    const currentState = diagnosisStates;
    const allPrincipalCodes = currentState?.principal?.map(
      (item) => item?.code
    );
    const allAdditionalCodes = currentState?.additional?.map(
      (item) => item?.code
    );
    const allProcedureCodes = currentState?.procedure?.map(
      (item) => item?.code
    );
    const payload = {
      hcp_line_id: lastHcpLineId,
      principal_diagnosis_code: allPrincipalCodes.join(","),
      additional_diagnoses_code: allAdditionalCodes,
      procedure_codes: allProcedureCodes,
      [drgKey]: drgValue,
      is_confirmed: true,
      ...((location.pathname === "/Auditor-Coding-Screen" ||
        location.pathname === "/Auditor-CodeAssist-Screen") && {
        is_audited: episodeStatus,
      }),
    };
    const principleClusterCodes = allPrincipalCodes?.map((val) => val) || [];
    const additionalClusterCodes = allAdditionalCodes?.map((val) => val) || [];
    const procedureClusterCodes = allProcedureCodes?.map((val) => val) || [];

    const allFinalClusterCodes = [
      ...principleClusterCodes,
      ...additionalClusterCodes,
      // ...procedureClusterCodes,
    ];
    const onlyAdditionalClusterCodes = additionalClusterCodes?.filter(
      (item) => ["1", "2"].includes(item?.[1]) && item
    );

    const onlyPrincipleClusterCodes = principleClusterCodes?.map((item) =>
      ["1", "2"].includes(item?.[1]) ? item.slice(2) : item.slice(1)
    );

    const clusterCodePayloadToSend = {
      principal_diagnosis: onlyPrincipleClusterCodes[0],
      diagnosis_codes: onlyAdditionalClusterCodes,
    };
    //   // if(!codebookusaEnv){

    //   if (
    //     clusterCodePayloadToSend?.principal_diagnosis?.length > 0 ||
    //     clusterCodePayloadToSend?.diagnosis_codes?.length > 0
    //   ) {
    //     dispatch(fetchClusterWarnings(clusterCodePayloadToSend))
    //       .unwrap()
    //       .then((result) => {
    //         const {warnings, errors} = result || [];

    //         if (warnings?.length === 0 && errors?.length === 0) {
    //           setdrgConfirmedStatusUpdate(true);
    //           acceptCode(payload, location.pathname)
    //             .then((res) => {
    //               if (data1.data.principal_diagnosis[0].code === null) {
    //                 toast.error(
    //                   "DRG cannot be confirmed without principal diagnosis"
    //                 );
    //                 setIsDrgConfirmed(false);
    //               } else {
    //                 toast.success("DRG Confirmed Successfully");
    //                 setIsDrgConfirmed(true);
    //               }
    //             })
    //             .catch((err) => {
    //               toast.success("Error occured while confirming DRG");
    //             })
    //             .finally(() => {
    //               setdrgConfirmedStatusUpdate(false);
    //               setAuditedStatus(false);
    //             })
    //             .finally(() => {
    //               setdrgConfirmedStatusUpdate(false);
    //               setAuditedStatus(false);
    //               setIsDrgConfirmed(false);
    //               setTimeout(() => {
    //                 // setDiagnosisStates(diagnosisStates);
    //                 fetchData1();
    //               }, 200);
    //               console.log(accepted, "accepted");

    //               // setAccepted({...accepted, [code]: false} );
    //               // sessionStorage.setItem("suppressCodebookFetch", "true");
    //               // window.location.reload();
    //               const currentScreen = localStorage.getItem("currentPage");
    //               const hcpLineId = localStorage.getItem("last_hcp_line_id");
    //               let newEpisodeRecord = null;
    //               const newEpisodeListFilterObj = JSON.parse(
    //                 localStorage.getItem("filters")
    //               );
    //               if (
    //                 location.pathname === "/coder" ||
    //                 location.pathname === "/Code-Assist"
    //               ) {
    //                 const payload = {
    //                   ...newEpisodeListFilterObj,
    //                   status: ["Coding Complete"], // override only for payload
    //                 };
    //                 // console.log('yes its executing eplist block');
    //                 dispatch(getFilterEpisodeLists(payload)).then((res) => {
    //                   console.log(res, "drgclickres");

    //                   const newEpisodeRecord = res.payload?.episode?.find(
    //                     (episode) => episode?.hcp_line_id === Number(hcpLineId)
    //                   );

    //                   if (newEpisodeRecord) {
    //                     dispatch(selectedEpisodeList(newEpisodeRecord));
    //                   }
    //                 });
    //               } else if (
    //                 location.pathname === "/Auditor-Coding-Screen" ||
    //                 location.pathname === "/Auditor-CodeAssist-Screen"
    //               ) {
    //                 // console.log('yes its executing coder block');
    //                 const payload = {
    //                   ...newEpisodeListFilterObj,
    //                   status: ["Audited"], // override only for payload
    //                 };
    //                 dispatch(getFilterEpisodeLists(payload)).then((res) => {
    //                   console.log(res, "drgclickres");

    //                   const newEpisodeRecord = res.payload?.episode?.find(
    //                     (episode) => episode?.hcp_line_id === Number(hcpLineId)
    //                   );

    //                   if (newEpisodeRecord) {
    //                     dispatch(selectedEpisodeList(newEpisodeRecord));
    //                   }
    //                 });
    //               } else if (currentScreen === "auditorPage") {
    //                 console.log("yes its executing audiot block");
    //                 dispatch(getFilterEpisodeLists(episodeListFilterObj)).then(
    //                   (res) => {
    //                     const newEpisodeRecord = res.payload?.episode?.find(
    //                       (episode) => episode?.hcp_line_id === Number(hcpLineId)
    //                     );

    //                     if (newEpisodeRecord) {
    //                       dispatch(selectedEpisodeList(newEpisodeRecord));
    //                     }
    //                     localStorage.setItem("episode-status-modal", "true");
    //                     setOpenStatusUpdatedModal(true);
    //                   }
    //                 );
    //               }

    //               // console.log(newEpisodeRecord, episodesFilterList, "newEpisodeRecord");
    //               // dispatch(selectedEpisodeList(episodeSelected));
    //             });
    //           // toast.warning("No Warnings");
    //         } else {
    //           setWarningModal(true);
    //         }
    //       })
    //       .catch((err) => {
    //         console.log("Warning API failed → still calling acceptCode()", err);
    //       });
    //   }
    // // }
    // if (!codebookusaEnv) {

    if (
      clusterCodePayloadToSend?.principal_diagnosis?.length > 0 ||
      clusterCodePayloadToSend?.diagnosis_codes?.length > 0
    ) {
      if (!codebookusaEnv) {
        dispatch(fetchClusterWarnings(clusterCodePayloadToSend))
          .unwrap()
          .then((result) => {
            const { warnings, errors } = result || [];

            if (warnings?.length === 0 && errors?.length === 0) {
              setdrgConfirmedStatusUpdate(true);
              acceptCode(payload, location.pathname)
                .then((res) => {
                  if (data1.data.principal_diagnosis[0].code === null) {
                    toast.error(
                      "DRG cannot be confirmed without principal diagnosis"
                    );
                    setIsDrgConfirmed(false);
                  } else {
                    // toast.success("DRG Confirmed Successfully");
                    // setIsDrgConfirmed(true);
                    if (typeOfPatient === "outPatient") {
                      console.log(typeOfPatient, "ggggg");
                      toast.success("Save codes Successfully");
                      setIsDrgConfirmed(true);
                    } else {
                      console.log("Hello");
                      toast.success("DRG Confirmed Successfully");
                      setIsDrgConfirmed(true);
                    }
                  }
                })
                .catch((err) => {
                  toast.success("Error occured while confirming DRG");
                })
                .finally(() => {
                  setdrgConfirmedStatusUpdate(false);
                  setAuditedStatus(false);
                })
                .finally(() => {
                  setdrgConfirmedStatusUpdate(false);
                  setAuditedStatus(false);
                  setIsDrgConfirmed(false);
                  setTimeout(() => {
                    fetchData1();
                  }, 200);
                  console.log(accepted, "accepted");

                  const currentScreen = localStorage.getItem("currentPage");
                  const hcpLineId = localStorage.getItem("last_hcp_line_id");
                  let newEpisodeRecord = null;
                  const newEpisodeListFilterObj = JSON.parse(
                    localStorage.getItem("filters")
                  );

                  if (
                    location.pathname === "/coder" ||
                    location.pathname === "/Code-Assist"
                  ) {
                    const payload = {
                      ...episodeListFilterObj,
                      status: ["Coding Complete"],
                    };
                    dispatch(getFilterEpisodeLists(payload)).then((res) => {
                      const newEpisodeRecord = res.payload?.episode?.find(
                        (episode) => episode?.hcp_line_id === Number(hcpLineId)
                      );
                      if (newEpisodeRecord) {
                        dispatch(selectedEpisodeList(newEpisodeRecord));
                      }
                    });
                  } else if (
                    location.pathname === "/Auditor-Coding-Screen" ||
                    location.pathname === "/Auditor-CodeAssist-Screen"
                  ) {
                    const payload = {
                      ...newEpisodeListFilterObj,
                      status: ["Audited"],
                    };
                    dispatch(getFilterEpisodeLists(payload)).then((res) => {
                      const newEpisodeRecord = res.payload?.episode?.find(
                        (episode) => episode?.hcp_line_id === Number(hcpLineId)
                      );
                      if (newEpisodeRecord) {
                        dispatch(selectedEpisodeList(newEpisodeRecord));
                      }
                    });
                  } else if (currentScreen === "auditorPage") {
                    dispatch(getFilterEpisodeLists(episodeListFilterObj)).then(
                      (res) => {
                        const newEpisodeRecord = res.payload?.episode?.find(
                          (episode) =>
                            episode?.hcp_line_id === Number(hcpLineId)
                        );
                        if (newEpisodeRecord) {
                          dispatch(selectedEpisodeList(newEpisodeRecord));
                        }
                        localStorage.setItem("episode-status-modal", "true");
                        setOpenStatusUpdatedModal(true);
                      }
                    );
                  }
                });
            } else {
              setWarningModal(true);
            }
          })
          .catch((err) => {
            console.log("Warning API failed → still calling acceptCode()", err);
          });
      } else {
        setdrgConfirmedStatusUpdate(true);
        acceptCode(payload, location.pathname)
          .then((res) => {
            if (data1.data.principal_diagnosis[0].code === null) {
              toast.error(
                "DRG cannot be confirmed without principal diagnosis"
              );
              setIsDrgConfirmed(false);
            } else {
              // toast.success("DRG Confirmed Successfully");
              // setIsDrgConfirmed(true);
              if (typeOfPatient === "outPatient") {
                console.log(typeOfPatient, "ggggg");
                toast.success("Save codes Successfully");
                setIsDrgConfirmed(true);
              } else {
                console.log("Hello");
                toast.success("DRG Confirmed Successfully");
                setIsDrgConfirmed(true);
              }
            }
          })
          .catch((err) => {
            toast.success("Error occured while confirming DRG");
          })
          .finally(() => {
            setdrgConfirmedStatusUpdate(false);
            setAuditedStatus(false);
          })
          .finally(() => {
            setdrgConfirmedStatusUpdate(false);
            setAuditedStatus(false);
            setIsDrgConfirmed(false);
            setTimeout(() => {
              fetchData1();
            }, 200);
          });
      }
    }

    // }
  };
  const handleConfirmDrgUSA = () => {
    // console.log("entered drg");
    setdrgConfirmedStatusUpdate(true);
    setAuditedStatus(true);
    const drgKey =
      location.pathname === "/Auditor-Coding-Screen" ||
      location.pathname === "/Auditor-CodeAssist-Screen"
        ? "audit_drg_code"
        : "drg_code";
    const episodeStatus =
      location.pathname === "/Auditor-Coding-Screen" ||
      location.pathname === "/Auditor-CodeAssist-Screen";

    const currentState = diagnosisStates;
    const allPrincipalCodes = currentState?.principal?.map(
      (item) => item?.code
    );
    const allAdditionalCodes = currentState?.additional?.map(
      (item) => item?.code
    );
    const allProcedureCodes = currentState?.procedure?.map(
      (item) => item?.code
    );
    const payload = {
      hcp_line_id: lastHcpLineId,
      principal_diagnosis_code: allPrincipalCodes.join(","),
      additional_diagnoses_code: allAdditionalCodes,
      procedure_codes: allProcedureCodes,
      [drgKey]: drgValue,
      is_confirmed: true,
      ...((location.pathname === "/Auditor-Coding-Screen" ||
        location.pathname === "/Auditor-CodeAssist-Screen") && {
        is_audited: episodeStatus,
      }),
    };

    acceptCode(payload, location.pathname)
      .then((res) => {
        if (typeOfPatient === "outPatient") {
          console.log(typeOfPatient, "ggggg");
          toast.success("Save codes Successfully");
          setIsDrgConfirmed(true);
        } else {
          console.log("Hello");
          toast.success("DRG Confirmed Successfully");
          setIsDrgConfirmed(true);
        }
      })
      .catch((err) => {
        toast.success("Error occured while confirming DRG");
      })
      .finally(() => {
        setdrgConfirmedStatusUpdate(false);
        setAuditedStatus(false);
      })
      .finally(() => {
        setdrgConfirmedStatusUpdate(false);
        setAuditedStatus(false);
        setIsDrgConfirmed(false);
        setTimeout(() => {
          // setDiagnosisStates(diagnosisStates);
          fetchData1();
        }, 200);
        console.log(accepted, "accepted");

        // setAccepted({...accepted, [code]: false} );
        // sessionStorage.setItem("suppressCodebookFetch", "true");
        // window.location.reload();
        const currentScreen = localStorage.getItem("currentPage");
        const hcpLineId = localStorage.getItem("last_hcp_line_id");
        let newEpisodeRecord = null;
        const newEpisodeListFilterObj = JSON.parse(
          localStorage.getItem("filters")
        );
        if (
          location.pathname === "/coder" ||
          location.pathname === "/Code-Assist"
        ) {
          const payload = {
            ...episodeListFilterObj,
            status: ["Coding Complete"], // override only for payload
          };
          
          // console.log('yes its executing eplist block');
          dispatch(getFilterEpisodeLists(payload)).then((res) => {
            console.log(res, "drgclickres");

            const newEpisodeRecord = res.payload?.episode?.find(
              (episode) => episode?.hcp_line_id === Number(hcpLineId)
            );

            if (newEpisodeRecord) {
              dispatch(selectedEpisodeList(newEpisodeRecord));
            }
          });
        } else if (
          location.pathname === "/Auditor-Coding-Screen" ||
          location.pathname === "/Auditor-CodeAssist-Screen"
        ) {
          // console.log('yes its executing coder block');
          const payload = {
            ...newEpisodeListFilterObj,
            status: ["Audited"], // override only for payload
          };
          dispatch(getFilterEpisodeLists(payload)).then((res) => {
            console.log(res, "drgclickres");

            const newEpisodeRecord = res.payload?.episode?.find(
              (episode) => episode?.hcp_line_id === Number(hcpLineId)
            );

            if (newEpisodeRecord) {
              dispatch(selectedEpisodeList(newEpisodeRecord));
            }
          });
        } else if (currentScreen === "auditorPage") {
          console.log("yes its executing audiot block");
          dispatch(getFilterEpisodeLists(episodeListFilterObj)).then((res) => {
            const newEpisodeRecord = res.payload?.episode?.find(
              (episode) => episode?.hcp_line_id === Number(hcpLineId)
            );

            if (newEpisodeRecord) {
              dispatch(selectedEpisodeList(newEpisodeRecord));
            }
            localStorage.setItem("episode-status-modal", "true");
            setOpenStatusUpdatedModal(true);
          });
        }

        // console.log(newEpisodeRecord, episodesFilterList, "newEpisodeRecord");
        // dispatch(selectedEpisodeList(episodeSelected));
      });
  };
  const handleEpisodeChange = () => {
    setTrackHistory([]);
    setRedoStack([]);
  };
  // console.log(lastCodedEpisode, "allDRGCodesTableData");
  const insertCode = async (code, description, type, warning) => {
    if (insertingCodes.has(code)) {
      // console.warn(`Skipping duplicate insertion for: ${code}`);
      return;
    }
    dispatch(setcurrentClusterID(nextClusterCurrentIndex));
    insertingCodes.add(code);
    return new Promise((resolve) => {
      setDiagnosisStates((prev) => {
        if (prev[type].some((item) => item.code === code)) {
          insertingCodes.delete(code);
          //console.warn(`Code already exists in ${type}, skipping: ${code}`);
          return prev;
        }
        const newCode = {
          code,
          description: description || `Description for ${code}`,
          warning,
        };
        const updatedState = {
          ...prev,
          [type]: type === "principal" ? [newCode] : [...prev[type], newCode],
        };
        localStorage.setItem(
          `${type}DiagnosisState`,
          JSON.stringify(updatedState[type])
        );
        return updatedState;
      });
      setTimeout(() => {
        setDiagnosisStates((updatedState) => {
          handleAccept(code, { code, description, warning }, type, updatedState)
            .then(() => insertingCodes.delete(code))
            .catch(() => insertingCodes.delete(code));
          return updatedState;
        });
        resolve();
      }, 0);
    });
  };
  const validateCodeAPI = async (code, type) => {
    // console.log(type, codebookdevEnv, "mhsgcjhs");
    if (type === "additional" || type === "principal") {
      type = "ICD";
    } else {
      type =
        codebookdevEnv ||
        codebookinternalEnv ||
        codebookcoblhEnv ||
        codebooknmhsEnv ||
        codebooksanEnv ||
        codebooksanhcEnv ||
        pallasaiTestCodebookEnv
          ? "ACHI"
          : codebookusaEnv
          ? "CPT"
          : "";
    }
    const url = "/checkIfCodeExists";
    const payload = {
      u_agey: data1?.data?.meta?.age_y,
      u_aged: data1?.data?.meta?.age_d,
      sex: data1?.data?.meta?.sex,
      code: code,
      check_for: type,
    };
    try {
      const response = await axiosInstance.post(url, payload);
      if (response.status === 200) {
        return {
          valid: response.data.code_exists,
          description: response.data.description || "",
          isWarning: response.data.is_warning || false,
          warningDescription: response.data.warning_description || "",
          isPopup: response.data.should_popup,
        };
      }
    } catch (error) {
      console.error("Error validating code", error);
    }
    return {
      valid: false,
      description: "",
      isWarning: false,
      warningDescription: "",
      isPopup: "",
    };
  };
  const handleCodeAssistAdding = async (draggedData, isRootCall = true) => {
    let toastId;

    if (isRootCall) {
      // Show a single "loading" toast only for root call
      toastId = toast.loading("Adding codes, please wait...");
      setSkipAcceptApi(true);
      setAuditedStatus(true);
    }

    try {
      const parsedData = JSON.parse(draggedData);

      // ✅ Check if draggedData is in new format
      const isNewFormat =
        parsedData.hasOwnProperty("Principal Diagnosis") ||
        parsedData.hasOwnProperty("Additional Diagnoses") ||
        parsedData.hasOwnProperty("Procedure Diagnosis");

      if (isNewFormat) {
        const sectionMap = {
          "Principal Diagnosis": "principal",
          "Additional Diagnoses": "additional",
          "Procedure Codes": "procedure",
        };

        for (const [key, type] of Object.entries(sectionMap)) {
          const entries = parsedData[key] || [];

          for (const entry of entries) {
            const codesToInsert = entry.codes || [];

            const fakeDraggedData = JSON.stringify({
              tab:
                type === "principal"
                  ? "Principal diagnosis"
                  : type === "additional"
                  ? "ICD 10 AM Index"
                  : "ACHI Tab",
              codes: codesToInsert,
            });

            // recursive call but no new toast
            await handleCodeAssistAdding(fakeDraggedData, false);
          }
        }

        if (isRootCall) {
          // ✅ all recursive inserts finished → update toast
          toast.update(toastId, {
            render: "All codes inserted successfully!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
        }
        return;
      }

      let type;

      if (parsedData.tab === "ICD 10 AM Index") {
        type = "additional";
      } else if (parsedData.tab === "Principal diagnosis") {
        type = "principal";
      } else {
        type = "procedure";
      }

      const { codes, tab } = parsedData;
      if (!codes || !Array.isArray(codes) || codes.length === 0) {
        if (isRootCall) {
          toast.update(toastId, {
            render: "Invalid codes!",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        }
        return;
      }

      const existingCodes = new Set([
        ...diagnosisStates["principal"].map((item) =>
          item?.code?.replace(/^[12]/, "")
        ),
        ...diagnosisStates["additional"].map((item) =>
          item?.code?.replace(/^[12]/, "")
        ),
        ...diagnosisStates["procedure"].map((item) =>
          item?.code?.replace(/^[12]/, "")
        ),
      ]);

      const isICD = tab.includes("ICD 10 AM");
      const isACHI = tab.includes("ACHI");
      if (
        (type === "procedure" && isICD) ||
        ((type === "additional" || type === "principal") && isACHI)
      ) {
        toast.warning(
          `${
            isICD ? "ICD" : "ACHI"
          } codes can't be inserted in ${type.toUpperCase()} section`
        );
        return;
      }

      let extractedCodesArray = [];
      codes.forEach((code) => {
        code = code.trim();
        if (!code) return;

        const match = code.match(/^\(([^)]+)\)(.+)$/);
        if (match) {
          extractedCodesArray.push(match[2].trim());
          extractedCodesArray.push(match[1].trim());
        } else {
          extractedCodesArray.push(code);
        }
      });

      let principalCode = extractedCodesArray[0];
      let additionalCodes = extractedCodesArray.slice(1);
      let prevPrincipal = diagnosisStates["principal"][0];
      let duplicateCodes = extractedCodesArray.filter((code) =>
        existingCodes.has(code.replace(/^[12]/, ""))
      );

      let uniqueNewCodes = extractedCodesArray.filter(
        (code) => !existingCodes.has(code.replace(/^[12]/, ""))
      );

      if (duplicateCodes.length > 0) {
        toast.warning(
          `Duplicate code${
            duplicateCodes.length > 1 ? "s" : ""
          } found: ${duplicateCodes
            .map((code) => code.replace(/^[12]/, ""))
            .join(", ")}`
        );
      }

      if (uniqueNewCodes.length === 0) {
        return; // No new codes to insert
      }

      let newPrincipalWarnings = [];
      let newAdditionalWarnings = [];
      let popupWarnings = [];

      const validationResults = await Promise.all(
        uniqueNewCodes.map(async (extractedCode) => {
          const validationType =
            extractedCode.replace(/^[12]/, "") ===
              principalCode.replace(/^[12]/, "") && type === "principal"
              ? "principal"
              : type === "procedure"
              ? "procedure"
              : "additional";

          const { valid, description, isWarning, warningDescription, isPopup } =
            await validateCodeAPI(extractedCode, validationType);

          if (!valid) return null;

          const warning = {
            is_warning: isWarning,
            should_popup: isPopup,
            warning_description: warningDescription,
          };

          if (isWarning && warningDescription) {
            if (validationType === "principal") {
              newPrincipalWarnings.push(warningDescription);
            } else {
              newAdditionalWarnings.push(warningDescription);
            }
          }

          if (isPopup) {
            popupWarnings.push({
              code: extractedCode,
              message: warningDescription,
            });
          }

          return { code: extractedCode, description, warning, validationType };
        })
      );

      const finalValidCodes = validationResults.filter(Boolean);
      if (finalValidCodes.length === 0) {
        toast.warning("No valid new codes to insert!");
        return;
      }

      const nonDuplicateValidCodes = finalValidCodes.filter(({ code }) => {
        const normalizedCode = code.replace(/^[12]/, "");
        if (existingCodes.has(normalizedCode)) {
          toast.warning(`Code ${normalizedCode} already exists!`);
          return false;
        }
        return true;
      });

      if (nonDuplicateValidCodes.length === 0) {
        toast.warning("Codes already exist!");
        return;
      }

      await Promise.all(
        nonDuplicateValidCodes.map(
          ({ code, description, warning, validationType }) =>
            insertCode(
              validationType !== "procedure"
                ? `2${code.replace(/^[12]/, "")}`
                : code,
              description,
              validationType,
              warning
            )
        )
      );

      setIconDispaly(true);
      saveToHistory();
      setDiagnosisStates((prevStates) => {
        let updatedStates = { ...prevStates };

        if (type === "principal") {
          const prevPrincipal = prevStates["principal"][0];
          const existingAdditional = prevStates["additional"];

          const principalEntry = nonDuplicateValidCodes.find(
            ({ code }) =>
              code.replace(/^[12]/, "") === principalCode.replace(/^[12]/, "")
          );

          const associatedAdditionalCodes = extractedCodesArray.slice(1);

          let additionalToPrepend = [];

          associatedAdditionalCodes.forEach((code) => {
            const normalizedCode = code.replace(/^[12]/, "");
            const alreadyInAdditional = existingAdditional.some(
              (item) => item.code.replace(/^[12]/, "") === normalizedCode
            );
            const foundEntry = nonDuplicateValidCodes.find(
              (item) => item.code.replace(/^[12]/, "") === normalizedCode
            );

            if (!alreadyInAdditional && foundEntry) {
              additionalToPrepend.push({
                ...foundEntry,
                code: `2${foundEntry.code.replace(/^[12]/, "")}`,
              });
            }
          });

          if (
            prevPrincipal &&
            !existingAdditional.some(
              (item) =>
                item.code.replace(/^[12]/, "") ===
                prevPrincipal.code.replace(/^[12]/, "")
            )
          ) {
            additionalToPrepend.push({
              ...prevPrincipal,
              code: `2${prevPrincipal.code.replace(/^[12]/, "")}`,
            });

            insertCode(
              `2${prevPrincipal.code.replace(/^[12]/, "")}`,
              prevPrincipal.description,
              "additional",
              prevPrincipal.warning
            );
          }

          const filteredAdditional = existingAdditional.filter(
            (item) =>
              !additionalToPrepend.some(
                (prepended) =>
                  prepended.code.replace(/^[12]/, "") ===
                  item.code.replace(/^[12]/, "")
              )
          );

          if (principalEntry) {
            updatedStates["principal"] = [
              {
                ...principalEntry,
                code: `2${principalEntry.code.replace(/^[12]/, "")}`,
              },
            ];
          }

          updatedStates["additional"] = [
            ...additionalToPrepend,
            ...filteredAdditional,
          ];
        }

        return updatedStates;
      });

      setWarningMessage((prevWarnings) => {
        let updatedWarnings = [...prevWarnings];

        const filteredPrincipalWarnings = newPrincipalWarnings.filter(
          (warning) => !popupWarnings.some((popup) => popup.message === warning)
        );

        const filteredAdditionalWarnings = newAdditionalWarnings.filter(
          (warning) => !popupWarnings.some((popup) => popup.message === warning)
        );

        if (filteredPrincipalWarnings.length > 0) {
          updatedWarnings = [
            filteredPrincipalWarnings[0],
            ...updatedWarnings.filter(
              (w) => w !== filteredPrincipalWarnings[0]
            ),
          ];
        }

        filteredAdditionalWarnings.forEach((warning) => {
          if (!updatedWarnings.includes(warning)) {
            updatedWarnings.push(warning);
          }
        });

        return updatedWarnings;
      });

      setNewlyInsertedCodes((prev) => [
        ...prev,
        ...nonDuplicateValidCodes.map(({ code }) => code),
      ]);

      const lastInsertedCode =
        nonDuplicateValidCodes[nonDuplicateValidCodes.length - 1]?.code;
      const popupWarning = popupWarnings.find(
        (w) => w.code === lastInsertedCode
      );
      if (popupWarning) {
        setPendingCode(lastInsertedCode);
        setPendingType(type);
        setModalMessage(popupWarning.message);
        setModalVisible(true);
      }

      // ✅ success toast only once (root)
      if (isRootCall && toastId) {
        toast.update(toastId, {
          render: "All codes inserted successfully!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error handling drop:", error);

      if (isRootCall && toastId) {
        toast.update(toastId, {
          render: "Failed to insert some codes.",
          type: "error",
          isLoading: false,
          autoClose: 4000,
        });
      }
    } finally {
      if (isRootCall) {
        setAuditedStatus(false);
        try {
          await fetchData1();
        } finally {
          setIsFetchingData1(false);
        }

        const newEpisodeListFilterObj = localStorage.getItem("filters");
        const hcpLineId = localStorage.getItem("last_hcp_line_id");
        dispatch(getFilterEpisodeLists(newEpisodeListFilterObj)).then((res) => {
          const newEpisodeRecord = res.payload?.episode?.find(
            (episode) => episode?.hcp_line_id === Number(hcpLineId)
          );

          if (newEpisodeRecord) {
            dispatch(selectedEpisodeList(newEpisodeRecord));
          }
        });
      }
    }
  };
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);
  return (
    <CodeContext.Provider
      value={{
        selectedCodeBookCode,
        setSelectedCodeBookCode,
        selectedTabKeyCoding,
        setSelectedTabKeyCoding,
        drgValue,
        drgloading,
        setDrgLoading,
        weightValue,
        reimbursementValue,
        copiedCodes,
        setCopiedCodes,
      }}
    >
      <div style={{ height: "90%" }}>
        <div className="main-container" style={{ height: "100%" }}>
          <Box
            className="epsoide-status-card"
            sx={{
              maxHeight: {
                lg: "25%",
                md: "25%",
                sm: "30%",
                xs: "30%",
              },
            }}
          >
            <EpisodeStatus
              drgData={drgData}
              setDrgData={setDrgData}
              selectedVersion={selectedVersion}
              setSelectedVersion={setSelectedVersion}
              drgValue={drgValue}
              setDrgValue={setDrgValue}
              episodesFilterList={episodesFilterList}
              isEpisodesLoading={isEpisodesLoading}
              waitTillLoad={waitTillLoad}
              setSkipAcceptApi={setSkipAcceptApi}
              codingscreendata={data1}
              setPasHyperLink={setPasHyperLink}
              pasHyperLink={pasHyperLink}
              handleDRGOptions={handleDRGOptions}
              handleDrgInformation={handleDrgInformation}
              handleConfirmDrg={
                codebookusaEnv
                  ? handleConfirmDrgUSA
                  : handleConfirmDrg
              }
              isDrgConfirmed={isDrgConfirmed}
              acceptedCodes={acceptedCodes}
              handleEpisodeChange={handleEpisodeChange}
              currentEpisode={currentEpisode}
              setCurrentEpisode={setCurrentEpisode}
              currentStatus={currentStatus}
              setCurrentStatus={setCurrentStatus}
              currentEpisodeNumber={currentEpisodeNumber}
              setCurrentEpisodeNumber={setCurrentEpisodeNumber}
              drgConfirmedStatusUpdate={drgConfirmedStatusUpdate}
              setOpenStatusUpdatedModal={setOpenStatusUpdatedModal}
            />
          </Box>
          <Grid
            className="coding-container-section"
            sx={{
              mt: {
                lg: typeOfPatient !== "outPatient" ? 0 : 4,
                md: typeOfPatient !== "outPatient" ? 0 : 3,
                sm: typeOfPatient !== "outPatient" ? 2 : 3,
                xs: typeOfPatient !== "outPatient" ? 2 : 3,
              },
            }}
          >
            <Grid
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{
                width: "100%",
                display: {
                  xs: "block",
                  md: "block",
                  lg: "flex",
                },
              }}
            >
              {isLargeScreen ? (
                <>
                  <Card
                    variant="outlined"
                    sx={{
                      display:
                        !documentationCard || !codingScreenCard || !codeBookCard
                          ? "flex"
                          : "none",
                      justifyContent: "space-around",
                      alignItems: "center",
                    }}
                  >
                    {!documentationCard && (
                      <Box
                        sx={{
                          /* height: fit-content; */
                          display: "flex",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          className="cards-btn"
                          onClick={() => dispatch(setDocumentationCard(true))}
                        >
                          Documentation​
                          <img
                            src={PlusIcon}
                            alt="plus"
                            className="cards-btn-img"
                          />
                        </Button>
                      </Box>
                    )}
                    {!codingScreenCard && (
                      <Box
                        sx={{
                          /* height: fit-content; */
                          display: "flex",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          className="cards-btn"
                          onClick={() => dispatch(setCodingScreenCard(true))}
                        >
                          Codingscreen
                          <img
                            src={PlusIcon}
                            alt="plus"
                            className="cards-btn-img"
                          />
                        </Button>
                      </Box>
                    )}
                    {!codeBookCard && (
                      <Box
                        sx={{
                          /* height: fit-content; */
                          display: "flex",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          className="cards-btn"
                          onClick={() => {
                            dispatch(setCodeBookCard(true));
                          }}
                        >
                          Codebook
                          <img
                            src={PlusIcon}
                            alt="plus"
                            className="cards-btn-img"
                          />
                        </Button>
                      </Box>
                    )}
                  </Card>
                </>
              ) : (
                <>
                  <Box
                    sx={{
                      my: {
                        sm: 1,
                        xs: 1,
                      },
                      // background: 'brown'
                    }}
                    className={`toggle-wrapper-side ${
                      !codeBookCard || !documentationCard || !codingScreenCard
                        ? "active-card"
                        : ""
                    }`}
                  >
                    {!documentationCard && (
                      <div className="cards-btn-container">
                        <button
                          className="cards-btn"
                          onClick={() => dispatch(setDocumentationCard(true))}
                        >
                          <span>Documentation​</span>
                          <img
                            src={PlusIcon}
                            alt="plus"
                            className="cards-btn-img"
                          />
                        </button>
                      </div>
                    )}
                    {!codingScreenCard && (
                      <div className="cards-btn-container">
                        <button
                          className="cards-btn"
                          onClick={() => dispatch(setCodingScreenCard(true))}
                        >
                          <span>Codingscreen</span>
                          <img
                            src={PlusIcon}
                            alt="plus"
                            className="cards-btn-img"
                          />
                        </button>
                      </div>
                    )}
                    {!codeBookCard && (
                      <div className="cards-btn-container">
                        <button
                          className="cards-btn"
                          onClick={() => {
                            dispatch(setCodeBookCard(true));
                          }}
                        >
                          <span>Codebook</span>
                          <img
                            src={PlusIcon}
                            alt="plus"
                            className="cards-btn-img"
                          />
                        </button>
                      </div>
                    )}
                  </Box>
                </>
              )}
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className="coding-screen-card"
                sx={{
                  width: {
                    lg:
                      documentationCard && codingScreenCard && codeBookCard
                        ? "35%"
                        : !codingScreenCard && !codeBookCard
                        ? "90%"
                        : !documentationCard
                        ? "0%"
                        : "50%",
                  },
                  // minHeight: {
                  //   lg: !codingScreenCard && !codeBookCard ? "975px" : "975px",
                  //   md: !codingScreenCard && !codeBookCard ? "975px" : "975px",
                  //   sm: !codingScreenCard && !codeBookCard ? "600px" : "600px",
                  //   xs: !codingScreenCard && !codeBookCard ? "600px" : "600px",
                  // },
                  height:
                    !codingScreenCard && !codeBookCard ? "975px" : "975px",
                  display:
                    documentationCard && codingScreenCard && codeBookCard
                      ? "flex"
                      : !documentationCard && "none",
                  justifyContent:
                    documentationCard && codingScreenCard && codeBookCard
                      ? "space-between"
                      : !documentationCard && "none",
                  alignItems:
                    documentationCard && codingScreenCard && codeBookCard
                      ? "start"
                      : !documentationCard && "none",
                }}
              >
                {/* <div className='documentation-heading-card'>
                      <div className='documentation-header-card'>
                      <p className='documentation-header-text'>Documentation</p>
                      <span className='documentation-header-icon'><img src={documentationIcon} /></span>
                      </div>
                      <button className='documentation-section-close-icon' 
                      onClick={() => toggleCollapse(1)}
                      >
                     <img src={closeIcon}/>
                      </button>
                    </div> */}
                <div className="coding-screen-section">
                  <div className="coding-screen-header">
                    <div className="documentation-card-header">
                      <p className="documentation-header-text">Documentation</p>
                      <span className="documentation-header-icon">
                        <img src={documentationIcon} alt="doc" />
                      </span>
                    </div>
                    <div className="documentation-header-right-side">
                      {
                        // (
                        //   permissionList?.includes("admin") &&
                        //   (
                        //     permissionList?.includes("Code Accelerate") ||
                        //     permissionList?.includes("Code Assist")
                        //   )
                        // )

                        (codebookdevEnv ||
                          codebookusaEnv ||
                          codebookinternalEnv) &&
                          (permissionList?.includes("admin") ||
                            permissionList?.includes("Code Accelerate") ||
                            permissionList?.includes("Code Assist")) && (
                            <Tooltip title="Upload your own documents">
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: "#0d3b66",
                                  mr: 1,
                                  borderRadius: "10px",
                                  fontSize: "12px",
                                  display: " flex",
                                  alignItems: "center",
                                }}
                                onClick={() => navigate("/upload-document")}
                              >
                                {/* Upload your own documents */}
                                <UploadFileIcon style={{ height: "15px" }} />
                              </Button>
                            </Tooltip>
                          )
                      }
                      <button
                        className="documentation-section-close-icon"
                        onClick={() => toggleCollapse(1)}
                      >
                        <img src={closeIcon} alt="close" />
                      </button>
                    </div>
                  </div>
                  <DocumentViewer episodeList={episodeList} />
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className="coding-screen-card card"
                sx={{
                  width: {
                    lg:
                      documentationCard && codingScreenCard && codeBookCard
                        ? "40%"
                        : !documentationCard && !codeBookCard
                        ? "90%"
                        : !codingScreenCard
                        ? "0%"
                        : "50%",
                  },
                  display:
                    documentationCard && codingScreenCard && codeBookCard
                      ? "flex"
                      : !codingScreenCard && "none",
                  minHeight: {
                    sm: "400px",
                    xs: "400px",
                  },
                }}
              >
                <div className="coding-screen-section">
                  <div className="coding-screen-header">
                    <div className="documentation-card-header">
                      <p className="documentation-header-text">
                        Coding screen​
                      </p>
                      <span className="documentation-header-icon">
                        <img src={gridImage} alt="grid" />
                      </span>
                    </div>
                    <div className="d-flex gap-2">
                      <Tooltip title="Undo your last action">
                        <button
                          disabled={trackHistory?.length === 0}
                          onClick={handleUndo}
                          className="undo-button"
                        >
                          <img
                            className="undo-icon"
                            src={undo_icon}
                            alt="undo"
                          />
                        </button>
                      </Tooltip>
                      <Tooltip title="Redo your last action">
                        <button
                          onClick={handleRedo}
                          disabled={redoStack?.length === 0}
                          className="redo-button"
                        >
                          <img
                            className="redo_icon"
                            src={undo_icon}
                            alt="redo"
                          />
                        </button>
                      </Tooltip>
                      <button
                        className="documentation-section-close-icon"
                        onClick={() => toggleCollapse(2)}
                      >
                        <img src={closeIcon} alt="close" />
                      </button>
                    </div>
                  </div>
                  {isLoadingCodingScreen ? (
                    <LdsRoller />
                  ) : (
                    <CodingScreen
                      drgData={drgData}
                      setDrgData={setDrgData}
                      selectedVersion={selectedVersion}
                      setSelectedVersion={setSelectedVersion}
                      setCodeBookCard={setCodeBookCard}
                      episodeListData={episodeList}
                      setDrgValue={setDrgValue}
                      setweightValue={setweightValue}
                      setReimbursementValue={setReimbursementValue}
                      codingscreendata={data1}
                      isLoadingCodingScreen={isLoadingCodingScreen}
                      setAccepted={setAccepted}
                      diagnosisStates={diagnosisStates}
                      setDiagnosisStates={setDiagnosisStates}
                      setTrackHistory={setTrackHistory}
                      setRedoStack={setRedoStack}
                      setWaitTillLoad={setWaitTillLoad}
                      skipAcceptApi={skipAcceptApi}
                      acceptedCodes={acceptedCodes}
                      setAcceptedCodes={setAcceptedCodes}
                      calculate_drg={calculate_drg}
                      isDrgConfirmed={isDrgConfirmed}
                      handleConfirmDrg={
                        codebookusaEnv
                          ? handleConfirmDrgUSA
                          : handleConfirmDrg
                      }
                      drgConfirmedStatusUpdate={drgConfirmedStatusUpdate}
                      setEnableFinalize={setEnableFinalize}
                      enableFinalize={enableFinalize}
                      auditedStatus={auditedStatus}
                      setAuditedStatus={setAuditedStatus}
                      handleCodeAssistAdding={handleCodeAssistAdding}
                      validateCodeAPI={validateCodeAPI}
                      insertCode={insertCode}
                      handleAccept={handleAccept}
                      iconDisplay={iconDisplay}
                      setIconDispaly={setIconDispaly}
                      saveToHistory={saveToHistory}
                      warningMessage={warningMessage}
                      setWarningMessage={setWarningMessage}
                      newlyInsertedCodes={newlyInsertedCodes}
                      setNewlyInsertedCodes={setNewlyInsertedCodes}
                      pendingCode={pendingCode}
                      setPendingCode={setPendingCode}
                      pendingType={pendingType}
                      setPendingType={setPendingType}
                      modalVisible={modalVisible}
                      setModalVisible={setModalVisible}
                      modalMessage={modalMessage}
                      setModalMessage={setModalMessage}
                      nextClusterCurrentIndex={nextClusterCurrentIndex}
                    />
                  )}
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className="coding-book-card"
                sx={{
                  width: {
                    lg:
                      documentationCard && codingScreenCard && codeBookCard
                        ? "25%"
                        : !documentationCard && !codingScreenCard
                        ? "90%"
                        : !codeBookCard
                        ? "0%"
                        : "50%",
                  },
                  height: "100%",
                  display: !codeBookCard && "none",
                }}
              >
                <div className="coding-screen-section">
                  <div className="coding-screen-header">
                    <div className="documentation-card-header">
                      <p className="documentation-header-text">Codebook</p>
                      <span className="documentation-header-icon">
                        <img src={codeBookIcon} alt="codebook" />
                      </span>
                    </div>
                    <button
                      className="documentation-section-close-icon"
                      onClick={() => toggleCollapse(3)}
                    >
                      <img src={closeIcon} alt="close" />
                    </button>
                  </div>
                  {codebookusaEnv && (
                    <CodeBookUsa
                      activeIcon={activeIcon}
                      activeTab={activeTab}
                      setActiveIcon={setActiveIcon}
                      setActiveTab={setActiveTab}
                    />
                  )}
                  {(codebookdevEnv ||
                    codebookinternalEnv ||
                    codebookcoblhEnv ||
                    codebooknmhsEnv ||
                    codebooksanEnv ||
                    pallasaiTestCodebookEnv ||
                    codebooksanhcEnv ||
                    codebookfigiEnv) && <CodeBookDev />}
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
        {drgModalVisible && (
          <div class="modal-overlay drg-modal">
            <div className="modal-overlay">
              <div className="drg-options-modal-content">
                <div class="modal-header">
                  <Typography
                    variant="h2"
                    sx={
                      {
                        // background: {
                        //   md: "brown",
                        //   sm: 'yellow',
                        //   xs: "blue"
                        // }
                      }
                    }
                  >
                    Grouping Options
                  </Typography>
                  <button className="close-button">&times;</button>
                </div>
                <Typography
                  className="modal-subtitle"
                  sx={{
                    fontSize: {
                      sm: "14px",
                      xs: "12px",
                    },
                  }}
                >
                  Select new principal diagnosis, if applicable
                </Typography>
                {drgOptionsLoading ? (
                  <Box
                    sx={{
                      height: {
                        lg: "auto",
                        md: "auto",
                        sm: "300px",
                        xs: "300px",
                      },
                      textAlign: "center",
                    }}
                  >
                    <LdsRoller />
                  </Box>
                ) : (
                  <>
                    {isMediumScreen ? (
                      <Box
                        sx={{
                          // background: "brown",
                          maxHeight: "300px",
                          overflow: "auto",
                          width: "auto",
                          borderRadius: "5px",
                        }}
                      >
                        {allDRGCodesTableData?.map((item, index) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              margin: "10px",
                              backgroundColor:
                                selectedRowIndex === index ? "#e6f7ff" : "fff",
                              padding: "10px",
                              borderRadius: "5px",
                              border: "1px solid #cdcdcd",
                            }}
                            onClick={() => setSelectedRowIndex(index)}
                          >
                            <Typography sx={{ fontSize: "12px" }}>
                              PDX-{" "}
                              {item?.principal_diagnosis
                                ?.replace(/[.\-']/g, "")
                                ?.replace(/\s*\[.*?\]\s*/g, "")
                                ?.slice(1)}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              PPX.2{" "}
                              {item?.procedure_codes === null ? (
                                <span>No procedure codes</span>
                              ) : (
                                <span>
                                  {Array.isArray(item?.procedure_codes)
                                    ? item.procedure_codes.length === 0
                                      ? "No procedure codes"
                                      : item.procedure_codes
                                          ?.join(", ")
                                          ?.replace(/[.\-']/g, "")
                                          ?.replace(/\s*\[.*?\]\s*/g, "")
                                    : item?.procedure_codes?.trim()
                                    ? item.procedure_codes
                                        ?.replace(/[.\-']/g, "")
                                        ?.replace(/\s*\[.*?\]\s*/g, "")
                                    : "No procedure codes"}
                                </span>
                              )}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              DRG: {item?.drg_code}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              weight:{" "}
                              {item?.weight === "can't determine"
                                ? "-"
                                : Number(item?.weight).toFixed(4)}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              ALOS -{item?.alos ?? "-"}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              REIMB $ -{" "}
                              {codebookusaEnv ? (
                                Math.round(item?.reimbursement ?? 0).toLocaleString()
                              ) : (
                                item?.weight === "can't determine"
                                  ? "-"
                                  : Math.round(item.weight * 6465).toLocaleString()
                              )}
                            </Typography>
                            <Typography sx={{ fontSize: "12px" }}>
                              PDX DESCRIPTION -{item?.description}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <div className="grouping-table-wrapper">
                        <table className="grouping-table">
                          <thead>
                            <tr>
                              <th>PDX</th>
                              <th>PPX.2</th>
                              <th>DRG</th>
                              <th>WEIGHT</th>
                              <th>ALOS</th>
                              <th>REIMB $</th>
                              <th>PDX DESCRIPTION</th>
                            </tr>
                          </thead>
                        </table>
                        <div className="table-body-scroll">
                          <table className="grouping-table">
                            <tbody>
                              {allDRGCodesTableData?.map((item, index) => (
                                <tr
                                  key={index}
                                  onClick={() => setSelectedRowIndex(index)}
                                  className={
                                    selectedRowIndex === index
                                      ? "selected-row"
                                      : ""
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <td>
                                    {item?.principal_diagnosis
                                      .replace(/[.\-']/g, "")
                                      .replace(/\s*\[.*?\]\s*/g, "")
                                      .slice(1)}
                                  </td>
                                  <td>
                                    {/* {console.log(
                                      item.procedure_codes,
                                      "itemprocedure_codes"
                                    )} */}
                                    {item?.procedure_codes === null ? (
                                      <span>No procedure codes</span>
                                    ) : (
                                      <span>
                                        {Array.isArray(item?.procedure_codes)
                                          ? item.procedure_codes.length === 0
                                            ? "No procedure codes"
                                            : item.procedure_codes
                                                .join(", ")
                                                .replace(/[.\-']/g, "")
                                                .replace(/\s*\[.*?\]\s*/g, "")
                                          : item?.procedure_codes?.trim()
                                          ? item.procedure_codes
                                              .replace(/[.\-']/g, "")
                                              .replace(/\s*\[.*?\]\s*/g, "")
                                          : "No procedure codes"}
                                      </span>
                                    )}
                                  </td>
                                  <td>{item?.drg_code}</td>
                                  <td>
                                    {item?.weight === "can't determine"
                                      ? "-"
                                      : Number(item?.weight).toFixed(4)}
                                  </td>
                                  <td>{item?.alos ?? "-"}</td>
                                  <td>
                                    {codebookusaEnv ? (
                                      Math.round(item?.reimbursement ?? 0).toLocaleString()
                                    ) : (
                                      item?.weight === "can't determine"
                                        ? "-"
                                        : Math.round(item.weight * 6465).toLocaleString()
                                    )}
                                  </td>
                                  <Tooltip title={item?.description}>
                                    <td>{item?.description}</td>
                                  </Tooltip>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </>
                )}

                <div class="modal-actions">
                  <button
                    class="cancel-button"
                    onClick={() => setDrgModalVisible(false)}
                  >
                    Cancel
                  </button>
                  <button class="ok-button" onClick={handleOkClick}>
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* {clusterCodeWarningsWarningList && clusterCodeWarningsWarningList?.warnings > 0 || clusterCodeWarningsWarningList && clusterCodeWarningsWarningList?.errors?.length > 0 && ( */}
        <WarningPanel
          show={warningModal}
          clusterCodeWarningsWarningList={
            clusterCodeWarningsWarningList?.warnings
          }
          clusterCodeWarningsErrorList={clusterCodeWarningsWarningList?.errors}
          onClose={() => {
            setWarningModal(false);
            dispatch(setClusterCodeWarningsWarningList([]));
          }}
        />
        {/* )} */}
      </div>
    </CodeContext.Provider>
  );
};

export default Coder;
